export class Terceiro {
  constructor({
    terceiroId,
    parceiroId,
    cpf,
    nome,
    matricula,
    areaId,
    email,
    celular,
    ativo,
  }) {
    this.terceiroId = terceiroId;
    this.parceiroId = parceiroId;
    this.cpf = cpf;
    this.nome = nome;
    this.matricula = matricula;
    this.areaId = areaId;
    this.email = email;
    this.celular = celular;
    this.ativo = ativo;
  }
}
